"use strict";

import helpers from "./_helpers";

const Modules = () => {
    const init = () => {
        $(document).ready(function () {
            set100vhSection();

            // GA Tracking
            TrackGAData();

            initInitialPopup();
            initConsentPopup();

            // Misc
            $('.js-scroll-to-quote').on('click', function (e) {
                e.preventDefault();

                let $linkSlider = $(this).closest('.js-link-slider-slide')

                if ($linkSlider.length) {
                    let span = $linkSlider.data('span')
                    let length = $linkSlider.data('length')
                    let wallHeight = $linkSlider.data('wall-height')
                    let quoteFor = $linkSlider.data('quote-for')

                    $("[name='width']").val('')
                    $("[name='length']").val('')
                    $("[name='height']").val('')
                    $("[name='quote_for']").val('')

                    if (span) {
                        $("[name='width']").val(span)
                    }
                    
                    if (length) {
                        $("[name='length']").val(length)
                    }

                    if (wallHeight) {
                        $("[name='height']").val(wallHeight)
                    }

                    if (quoteFor) {
                        $("[name='quote_for']").val(quoteFor)
                    }
                }

                let $quote_form = $(document).find('#request-quote-form');
                if ($quote_form.length) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $quote_form.offset().top - 100
                    }, 200);
                }
            });

            var $read_more_container = $('.js-read-more-container');
            if($read_more_container.length) {
                if(helpers.isMobile()) {
                    $read_more_container.each(function() {
                        // Wrap contents in wrapper div
                        const inner_div = $('<div>').addClass('read-more-container-inner js-read-more-container-inner');
                        const read_more_button = $('<span>').addClass('read-more-toggle js-read-more-toggle').text('Read more');

                        // Move all child nodes of the div into the span
                        $(this).contents().appendTo(inner_div);

                        // Append the span back to the div and add read more button
                        $(this).addClass('read-more-container').append(inner_div).append(read_more_button);
                    });


                    $(document).on('click','.js-read-more-toggle', function (e) {
                        e.preventDefault();
                        const container = $(this).parent('.js-read-more-container');
                        const content = container.find('.js-read-more-container-inner');
                        const toggle = container.find('.js-read-more-toggle');

                        if (container.hasClass('open')) {
                            // Collapse
                            container.removeClass('open').css('max-height', '');
                            toggle.text('Read more');
                        } else {
                            // Expand dynamically
                            const fullHeight = content.outerHeight(); // Get the full height of the content
                            container.addClass('open').css('max-height', fullHeight + 'px');
                            toggle.text('Read less');
                        }
                    });
                }
            }

            var $load_more_container = $('.js-load-more-container');
            if($load_more_container.length) {
                $load_more_container.each(function() {
                    const $container = $(this);
                    const $content = $container.find('.js-load-more-container-inner');
                    const content_original_height = $content.outerHeight() + 'px';
                    const reduced_height = ($container.find('.swiper-slide').first().outerHeight() * 2) + 'px';

                    // Store original and reduced heights on the element
                    $content.data('original-height', content_original_height);
                    $content.data('reduced-height', reduced_height);

                    // Collapse by default
                    $content.addClass('reduced').css('max-height', reduced_height);
                });

                $(document).on('click','.js-load-more-toggle', function (e) {
                    e.preventDefault();
                    const $toggle = $(this);
                    const $container = $toggle.closest('.js-load-more-container');
                    const $content = $container.find('.js-load-more-container-inner');

                    if ($content.hasClass('reduced')) {
                        // Expand dynamically
                        $content.removeClass('reduced').css('max-height', $content.data('original-height'));
                        $toggle.find('span').text('Show less');
                    } else {
                        // Collapse
                        $content.addClass('reduced').css('max-height', $content.data('reduced-height'));
                        $toggle.find('span').text('Load more');
                    }
                });
            }

            // Promo banner
            var $promo_banner = $('.js-promo-banner');

            if($promo_banner.length) {
                var promo_cookie = helpers.getCookie('promo-banner');
                if (!promo_cookie) {
                    $promo_banner.addClass('open');
                }
            }

            $('.js-promo-banner-close').on('click', function () {
                $('.js-promo-banner').removeClass('open');
                // Set cookie for 24 hours
                var expire = new Date();
                expire.setDate(expire.getDate()+1);
                helpers.setCookie('promo-banner', 'closed', expire);
            });

            $('.js-area-nav-menu-item').on('click', function () {
                var $area_container = $(document).find('.js-area-container[data-area-id="' + $(this).attr('data-area') + '"]');

                if(!$area_container.length) {
                    return;
                }

                $([document.documentElement, document.body]).animate({
                    scrollTop: $area_container.offset().top - 100
                }, 200);
            });

            // Site banner
            var $site_banner = $('.js-site-banner');

            if($site_banner.length) {
                var banner_last_scroll_top = 0;

                // Check to see if data should load in.
                $.request('zimpleGlobals::onGetSiteBannerContent', {
                    success: function (result_data) {
                        if(result_data['text']) {
                            $site_banner.find('.copy').html(result_data['text']);
                            $site_banner.addClass('js-filled').addClass('banner-' + result_data['colour']);

                            // If set to not show then dont
                            if(result_data['show_on_mobile'] == '0' && helpers.isMobileMenu()) {
                                return;
                            } else {
                                $site_banner.addClass('js-can-be-shown');
                            }
                            showHideSiteBanner($(window).scrollTop());
                        }
                    },
                    error: function (result_data) {
                        // console.log('error');
                    }
                });

                $(window).on('scroll resize', function() {
                    showHideSiteBanner($(this).scrollTop());
                });
            }

            // Quote form
            var $shed_as_metal = $('.js-shed-as-metal');
            if($shed_as_metal.length) {
                var module_wrapper = $shed_as_metal.parents('.js-quote-form-container');
                var form_type = $shed_as_metal.attr('value').replace('shed', 'metal building');
                module_wrapper.find('.js-quote-form-type').text(' - Your ' + form_type.replace('_', ' '));
            }

            $('.js-quote-type').on('click', function () {
                var module_wrapper = $(this).parents('.js-quote-form-container');
                if($(this).attr('value') == 'kit_home') {
                    module_wrapper.find('.js-shed-field').hide();
                    module_wrapper.find('.js-kithome-field').show();

                    module_wrapper.find('.js-shed-field').each(function() {
                        if($(this).find('label').hasClass('required')) {
                            $(this).find('input').prop('required', false);
                        }
                    });
                } else {
                    module_wrapper.find('.js-kithome-field').hide();
                    module_wrapper.find('.js-shed-field').show();
                    module_wrapper.find('.js-shed-field').removeClass('filled');

                    module_wrapper.find('.js-shed-field').each(function() {
                        if($(this).find('label').hasClass('required')) {
                            $(this).find('input').prop('required', true);
                        }
                    });

                    module_wrapper.find('.js-no-dimensions').removeClass('not-required').prop('checked', false);
                }

                var form_type = $(this).attr('value').replace('commercial_', '');

                if(module_wrapper.find('.js-shed-as-metal').length) {
                    form_type = form_type.replace('shed', 'metal building')
                }

                module_wrapper.find('.js-quote-form-type').text(' - Your ' + form_type.replace('_', ' '));

                if($(this).attr('value') == 'shed') {
                    module_wrapper.find('.js-dream-header').find('.h6').text('Tell us about your dream shed');
                }
                else if($(this).attr('value') == 'carport') {
                    module_wrapper.find('.js-dream-header').find('.h6').text('Tell us about your dream carport');
                }
                else if($(this).attr('value') == 'commercial_building') {
                    module_wrapper.find('.js-dream-header').find('.h6').text('Tell us about your dream building');
                }
                else if($(this).attr('value') == 'kit_home') {
                    module_wrapper.find('.js-dream-header').find('.h6').text('Tell us about your dream kit home');
                }
            });

            var $prefill_form = $('.js-set-default-values-form-container');
            if($prefill_form.length) {
                var override_default_value = $('body').attr('data-quote-form-default-value');

                if(override_default_value && override_default_value.length > 0) {
                    $prefill_form.each(function() {
                        $(this).find('.js-quote-type[value="' + override_default_value + '"]').attr('checked', true).trigger('click');
                        $(this).find('.js-quote-form-step-two').find("[name='quote_type']").val(override_default_value);
                    });
                }

                var variant_id_prefill = $('body').attr('data-prefill-variant-id');
                if(variant_id_prefill && variant_id_prefill.length > 0) {
                    $prefill_form.each(function() {
                        $(this).find('.js-prefill-product-id-field').val(variant_id_prefill);
                    });
                }

                var title_prefill = $('body').attr('data-prefill-variant-title');
                if(title_prefill && title_prefill.length > 0) {
                    $prefill_form.each(function() {
                        $(this).find('.js-prefill-product-name-field').val(title_prefill);
                    });
                }

                var length_prefill = $('body').attr('data-prefill-length');
                if(length_prefill && length_prefill.length > 0) {
                    $prefill_form.each(function() {
                        $(this).find('.js-prefill-length-field').val(length_prefill);
                    });
                }

                var width_prefill = $('body').attr('data-prefill-width');
                if(width_prefill && width_prefill.length > 0) {
                    $prefill_form.each(function() {
                        $(this).find('.js-prefill-width-field').val(width_prefill);
                    });
                }

                var height_prefill = $('body').attr('data-prefill-height');
                if(height_prefill && height_prefill.length > 0) {
                    $prefill_form.each(function() {
                        $(this).find('.js-prefill-height-field').val(height_prefill);
                    });
                }

                var price_prefill = $('body').attr('data-prefill-price');
                if(price_prefill && price_prefill.length > 0) {
                    $prefill_form.each(function() {
                        $(this).find('.js-prefill-product-price-field').val(price_prefill);
                    });
                }

                var category_prefill = $('body').attr('data-prefill-category');
                if(category_prefill && category_prefill.length > 0) {
                    $prefill_form.each(function() {
                        $(this).find('.js-prefill-product-category-field').val(category_prefill);
                    });
                }
            }

            $('.js-quote-form-back').on('click', function (e) {
                e.preventDefault();
                showStepOne($(this));
            });

            $('.js-no-dimensions').off('click');
            $('.js-no-dimensions').on('click', function (e) {
                var module_wrapper = $(this).parents('.js-quote-form-container');

                if ($(this).hasClass('not-required')) {
                    $(this).removeClass('not-required');
                    module_wrapper.find('.js-no-dimensions-field').removeClass('not-required');

                    module_wrapper.find('.js-shed-field').each(function() {
                        if($(this).find('label').hasClass('required')) {
                            $(this).find('input').prop('required', true);
                        }
                    });
                    return;
                }

                $(this).addClass('not-required');
                module_wrapper.find('.js-no-dimensions-field').addClass('not-required');

                module_wrapper.find('.js-no-dimensions-field').each(function() {
                    if($(this).find('label').hasClass('required')) {
                        $(this).find('input').prop('required', false);
                    }
                });
            });

            $('.js-copy-value').on('input', function(){
                var module_wrapper = $(this).parents('.js-quote-form-container');
                module_wrapper.find('.js-quote-form-step-two').find("[name='" + $(this).attr('name') + "']").val($(this).val());
            });

            $('.js-floorplan-option').on('click', function (e) {
                var module_wrapper = $(this).parents('.js-radio-list-field');
                module_wrapper.find('.js-floorplan-option-field').val($(this).val());
            });

            $('.js-floorplan-checkbox-option').on('click', function (e) {
                var module_wrapper = $(this).parents('.js-checkbox-list-field');

                var selected_options = '';
                module_wrapper.find('.js-floorplan-checkbox-option').each(function() {
                    if($(this).is(':checked')) {
                        selected_options += $(this).val() + ', ';
                    }
                });
                selected_options = selected_options.slice(0, -2);

                module_wrapper.find('.js-floorplan-option-field').val(selected_options);
            });

            $('.js-trigger-brochure-form').on('click', function (e) {
                $('.js-popup-brochure-form-heading').text('Request ' + $(this).parents('.js-floorplan-buttons').attr('data-flooplan-form-title') + ' brochure');
                $('.js-brochure-floorplan').val($(this).parents('.js-floorplan-buttons').attr('data-flooplan-form-title'));
            })

            // Agent details
            var $agent_page = $('.js-is-agent-page');
            if($agent_page.length) {
                // Only set header form to go to agent if they are high value
                $('.js-allow-high-value-agent').each(function() {
                    $(this).find('.js-high-value-agent').each(function() {
                        $(this).val($agent_page.attr('data-agent-id'));
                    });
                });
            }

            // Header form
            var $header = $('.js-header-quote-form-container');
            if($header.length) {
                // Set the header form to show as 'header' not 'inline'. Used for form tracking
                $header.find('.js-form-location').each(function() {
                    $(this).val('header');
                });
            }

            // Colour selector
            var $colour_selector = $('.js-colour-selector-container');
            if($colour_selector.length) {
                $colour_selector.find('.js-colour-picker').on({
                    mouseover: function () {
                        if(!helpers.isMobile()) {
                            setColour($(this));
                        }
                    },
                    mouseleave: function () {
                        if(!helpers.isMobile()) {
                            var active_picker = $colour_selector.find('.js-colour-picker.active');
                            setColour(active_picker);
                        }
                    }
                });

                $colour_selector.find('.js-colour-picker').on('click', function (e) {
                    $colour_selector.find('.js-colour-picker').removeClass('active');
                    $(this).addClass('active');
                    setColour($(this));
                })
                $colour_selector.find('.js-colour-picker').first().click();
            }

            // floorplans
            var $floorplans = $('.js-module-floorplans');
            if($floorplans.length) {
                var floorplan_tab = helpers.getUrlParameter('floorplan');

                // Pre open the floorplan tab based on what was chosen
                if(floorplan_tab) {
                    $floorplans.find('.js-tabs-tab[data-id="' + floorplan_tab + '"]').click();
                }
            }

            // kit home Filter
            var $kit_home_filter = $('.js-kit-home-filter-list');
            if($kit_home_filter.length) {
                $(document).on('click','.js-open-kit-homes-filters', function (e) {
                    e.preventDefault();
                    $kit_home_filter.find('.js-module-kit-homes-filter-sidebar').addClass('open');
                });

                $(document).on('click','.js-close-kit-homes-filters', function (e) {
                    e.preventDefault();
                    $kit_home_filter.find('.js-module-kit-homes-filter-sidebar').removeClass('open');
                });
            }

            function showHideSiteBanner(scroll_top) {
                // If no content then dont show
                if(!$site_banner.hasClass('js-filled') || !$site_banner.hasClass('js-can-be-shown')) {
                    return;
                }

                var banner_height = $site_banner.outerHeight();
                var mobile_button_height = $('.js-header-button-container').outerHeight();

                // Caters for safari where the scroll top can be in the negative
                if(banner_last_scroll_top < 0) {
                    banner_last_scroll_top = 0;
                }

                if(scroll_top <= 0) {
                    $site_banner.css('bottom', mobile_button_height);
                    $site_banner.addClass('promo-banner-is-showing');

                    if(!helpers.isMobile()) {
                        $('body').css('margin-top', banner_height);
                        $('header').css('top', banner_height);
                    }
                } else {
                    $('body').css('margin-top', 0);
                    $('header').css('top', 0);
                    $site_banner.removeClass('promo-banner-is-showing');
                }

                if(scroll_top <= banner_last_scroll_top) {
                    $site_banner.css('bottom', mobile_button_height);
                    $site_banner.addClass('promo-banner-is-showing');

                    if(!helpers.isMobile()) {
                        $('body').css('margin-top', banner_height);
                        $('header').css('top', banner_height);
                    }
                }
                else {
                    $('body').css('margin-top', 0);
                    $('header').css('top', 0);
                    $site_banner.removeClass('promo-banner-is-showing');
                }

                banner_last_scroll_top = scroll_top;
            }

            function setColour($picker) {
                var image = $colour_selector.find('.js-colour-selector-image');
                var svg = image.find('svg');
                svg.find('path, polygon').css({fill: $picker.attr('data-hex-code'), opacity: $picker.attr('data-opacity') + '%'});
                $colour_selector.find('.js-colour-name').html($picker.attr('data-title'));
                image.removeClass('loading');

                if(helpers.isMobile()) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: ($colour_selector.find('.js-colour-selector-image').offset().top - 70)
                    }, 200);
                }
            }

            function set100vhSection() {
                // Sets each 100vh section to the height of the available space taking into consideration the mobile's nav bar
                if($('.js-100-vh').length) {
                    $('.js-100-vh').each(function() {
                        $(this).css('height', '');

                        var extra_reduction = ($(this).hasAttr('data-100vh-extra-reduction') ? ' - ' + $(this).attr('data-100vh-extra-reduction') : '')
                        if(helpers.isMobileMenu()) {
                            $(this).css('height', 'calc(' + window.innerHeight + 'px' + extra_reduction + ')');
                        }
                    });
                }
            }

             function initInitialPopup() {
                 const hasSeenInitialPopup = helpers.getCookie('initial_popup_shown');

                 if (hasSeenInitialPopup !== 'true' && $('.js-initial-popup').length) {
                     openPopout('initial_popup');

                     let date = new Date();
                     date.setMonth(date.getMonth() + 5); // 5 month from now
                     let expires = date.toUTCString();
                     helpers.setCookie('initial_popup_shown', 'true', expires);
                 }
            }

             function initConsentPopup() {
                if (localStorage.getItem('cookie_consent') == null && $('.js-consent-popup').length) {
                    openPopout('consent_popup');
                }
            }

            function TrackGAData() {
                var utm_id = helpers.getUrlParameter('utm_id');
                var utm_source = helpers.getUrlParameter('utm_source');
                var utm_medium = helpers.getUrlParameter('utm_medium');
                var utm_campaign = helpers.getUrlParameter('utm_campaign');
                var utm_term = helpers.getUrlParameter('utm_term');
                var utm_content = helpers.getUrlParameter('utm_content');

                var tracking_data = {};
                var new_utm_data_set = false;

                // Update cookie if UTM data is present in URL
                if(utm_id ||
                    utm_source ||
                    utm_medium ||
                    utm_campaign ||
                    utm_term ||
                    utm_content
                ) {
                    tracking_data.ga_campaign_id = utm_id;
                    tracking_data.ga_campaign_source = utm_source;
                    tracking_data.ga_campaign_medium = utm_medium;
                    tracking_data.ga_campaign_name = utm_campaign;
                    tracking_data.ga_campaign_term = utm_term;
                    tracking_data.ga_campaign_content = utm_content;
                    new_utm_data_set = true;
                }

                // Check for referrer
                var referrer_url = '';
                var referrer_temp = ''+document.referrer;
                if (referrer_temp &&
                    referrer_temp != '' &&
                    typeof(document.referrer) != 'undefined' &&
                    referrer_temp.indexOf('//'+window.location.hostname+'/') < 0)
                {
                    referrer_url = referrer_temp;
                }

                tracking_data.ga_landing_page = window.location.href; // Page first landed on when entered site
                tracking_data.ga_referrer = referrer_url;

                // Check for user cookie which is used for first touch of the site
                var has_user_tracking_cookie = helpers.getCookie('ga-tracking-user');
                if(!has_user_tracking_cookie) {
                    // Set cookie for 400 days in future as that's the max at time of writing
                    var expiry_user = new Date();
                    expiry_user.setDate(expiry_user.getDate() + 400);
                    helpers.setCookie('ga-tracking-user', JSON.stringify(tracking_data), expiry_user);
                }

                // Check for session cookie
                var has_tracking_cookie = helpers.getCookie('ga-tracking-session');
                if(!has_tracking_cookie || new_utm_data_set) {
                    // Set cookie for 24 hours
                    var expire = new Date();
                    expire.setDate(expire.getDate()+1);
                    helpers.setCookie('ga-tracking-session', JSON.stringify(tracking_data), expire);
                }

                // Load in if data has been set
                var tracking_cookie_user = helpers.getCookie('ga-tracking-user');
                if (tracking_cookie_user) {
                    tracking_cookie_user = JSON.parse(tracking_cookie_user);

                    for (var key in tracking_cookie_user) {
                        $('input.js-' + key.replaceAll('_', '-') + '-first').each(function() {
                            if(tracking_cookie_user[key] !== undefined && tracking_cookie_user[key]) {
                                $(this).val(tracking_cookie_user[key]);
                            }
                        });
                    }
                }
                var tracking_cookie = helpers.getCookie('ga-tracking-session');
                if (tracking_cookie) {
                    tracking_cookie = JSON.parse(tracking_cookie);

                    for (var key in tracking_cookie) {
                        $('input.js-' + key.replaceAll('_', '-')).each(function() {
                            if(tracking_cookie[key] !== undefined && tracking_cookie[key]) {
                                $(this).val(tracking_cookie[key]);
                            }
                        });
                    }
                }
            }

        });
    };

    return {
        init: init
    };
};

export default Modules;